.Main {
    line-height: 1.7;
    padding: var(--small-space) 0 0 0;
}

.Main strong {
    font-weight: normal;
    font-variation-settings: "wght" 600;
}

.Main a {
    text-decoration: none;
    border-bottom: solid 2px currentColor;
}